import React from 'react';

import { LoaderContainer, LoaderImage } from './styles';

const Loader = () => {
  return (
    <LoaderContainer>
      <LoaderImage />
    </LoaderContainer>
  );
};

export default Loader;
